module.exports = __webpack_public_path__ + "img/report-issue.cea8aa8e.svg";